export enum SSHInstanceStatus {
  Pending = 'pending',
  Running = 'running',
  SSHReady = 'ssh_ready',
  Completed = 'completed',
  Failed = 'failed',
  Cancelled = 'cancelled',
  Terminated = 'terminated',
}

// Display labels - merges similar statuses for UI
// Running + SSH Ready => Running
// Completed + Terminated + Cancelled => Terminated
export const SSHInstanceStatusLabel: Record<SSHInstanceStatus, string> = {
  [SSHInstanceStatus.Pending]: 'Pending',
  [SSHInstanceStatus.Running]: 'Running',
  [SSHInstanceStatus.SSHReady]: 'Running',
  [SSHInstanceStatus.Completed]: 'Terminated',
  [SSHInstanceStatus.Failed]: 'Failed',
  [SSHInstanceStatus.Cancelled]: 'Terminated',
  [SSHInstanceStatus.Terminated]: 'Terminated',
};

// Unique status options for filter dropdown
export const SSHInstanceStatusFilterOptions = [
  { label: 'Pending', values: [SSHInstanceStatus.Pending] },
  { label: 'Running', values: [SSHInstanceStatus.Running, SSHInstanceStatus.SSHReady] },
  { label: 'Terminated', values: [SSHInstanceStatus.Completed, SSHInstanceStatus.Cancelled, SSHInstanceStatus.Terminated] },
  { label: 'Failed', values: [SSHInstanceStatus.Failed] },
];

export interface SSHInstance {
  task_id: string;
  task_name: string;
  status: SSHInstanceStatus;
  start_time: number | null;
  end_time: number | null;
  project_id: string;
  project_name: string;
  gpu_type: string;
  instance_ip: string | null;
  created_at: number | null;
  deleted_at: number | null;
}

export interface ListSSHInstancesResponse {
  status: string;
  instances: SSHInstance[];
  total: number;
}

export type GPUInstance = SSHInstance;

export interface RunSSHPayload {
  gpu_type: string;
  volume_size: number;
  rootfs_size: number;
  project_name?: string;
}

export interface GetGPUInstanceByIdRequest {
  instance_id: string;
}

export interface GetGPUInstanceByIdResponse extends GPUInstance {}

// SSE Event Data Types
export interface SSESSHKeyData {
  private_key: string;
}

export interface SSESSHReadyData {
  host: string;
  port: number;
}

export interface TerminateSSHResponse {
  status: string;
  task_id: string;
  details: string;
}
